import axios from "axios";
let APL_LINK = "http://192.168.1.69:8000/";
APL_LINK = "https://backendpython.advancecollisionrepair.com/";

let version_vi_api_website = APL_LINK + "api/v1/Website/";
// new API
const get_blog_data_website = version_vi_api_website + "get_blog_data_website";
const save_contact_estimate = version_vi_api_website + "save_contact_estimate";
const get_home_page_data  = version_vi_api_website + "get_home_page_data";
const get_faq_by_page = version_vi_api_website + "get_faq_by_page";
const blog_details_website = version_vi_api_website + "blog_details_website";
const get_seo_data_website = version_vi_api_website + "get_seo_data_website";
const MOBILE_NO ="(847) 250-7280";
const MOBILE_NO_CALL ="8472507280";
const EMAIL_CALL ="info@advancecollision.com";

const server_post_data = async (url_for, form_data) => {
  try {
    if (form_data === null) {
      form_data = new FormData();
    }

    const response = await axios.post(url_for, form_data);
    return response;
  } catch (error) {
    throw error;
  }
};

export {
  APL_LINK,
  server_post_data,
  save_contact_estimate,
  get_blog_data_website,
  get_faq_by_page,
  get_home_page_data,
  blog_details_website,
  get_seo_data_website,
  MOBILE_NO,
  MOBILE_NO_CALL,
  EMAIL_CALL,
};
